// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ChartHeader = styled.h3`
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 16px;
  margin-bottom: 5px;
  color: #333;
  display: block;
`;

export const Table = styled.table`
  margin: 0 0 15px 0;
  float: none;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  width: 100%;
  background-color: #fff;
  text-align: center;
  font-size: 12px;
  color: #595959;
  font-weight: 800;
  border-spacing: 0px;
`;

export const TableHeaders = styled.th`
  padding: 8px;
  width: 9%;
  background-color: #003057;
  font-weight: 900;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  border-right: white 2px solid !important;
`;

export const TableCells = styled.td`
  padding: 0.75em 5px;
  vertical-align: middle;
  border-right: white 2px solid !important;
  ${(props) => (props.isSingleSizeColumn ? `width:50%;` : ``)}
`;

export const TableRows = styled.tr`
  background-color: ${(props) => (props.isOdd ? '#f3f3f3' : 'transparent')};
`;
